/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Sub_Quotas_Pagination_InfoInputs */



/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Sub_Quotas_Pagination_InfoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_pagination_info = /** @type {((inputs: Sub_Quotas_Pagination_InfoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Pagination_InfoInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.page} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
});